import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "cmi00200-form-area" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 2 }

import { reactive, ref } from 'vue';
import axios from 'axios';
import Loading from 'quasar/src/plugins/Loading.js';;
import { useRouter } from 'vue-router';
import HttpResponseStatusCode from '../../common/code/HttpResponseStatusCode';
import AfiliationInfoForm from '../../components/form/member/AfiliationInfoForm.vue';
import AlertDialog from '../../components/dialogs/AlertDialog.vue';
import ConfirmationForm from '../../components/form/member/ConfirmationForm.vue';
import FormFooterBanner from '../../components/banner/FormFooterBanner.vue';
import InputFormHeader from '../../components/utils/InputFormHeader.vue';
import PageHeaderBanner from '../../components/banner/PageHeaderBanner.vue';
import UserInfoForm from '../../components/form/member/UserInfoForm.vue';
import DisplayModeCode from '../../common/code/DisplayModeCode';
import ResultStatusCode from '../../common/code/ResultStatusCode';
import DetailResultStatusCode from '../../common/code/DetailResultStatusCode';
import MessageChip from '../../components/chip/MessageChip.vue';
import * as UserAttributeCode from '../../common/code/UserAttributeCode';


export default /*@__PURE__*/_defineComponent({
  __name: 'CMI00200',
  setup(__props) {

const router = useRouter();

// ページ(0:ユーザー情報 1:所属先情報 2:変更内容確認)
const page = ref(0);
// Stepperに表示するタイトル
const titleList = ['ユーザー情報', '所属先情報', '変更内容確認'];
// 更新確認ダイアログフラグ
const isConfirmationFlg = ref(false);
// 更新完了ダイアログフラグ
const updateFlg = ref(false);
// エラーメッセージ
const errMessage = ref('');
// MessageChip表示フラグ
const isMessageChip = ref(false);
// 会員情報
const mKaiinInfo = reactive({
  user_name_sei: '',
  user_name_mei: '',
  mail_address: '',
  mail_address_conf: '',
  user_attribute: UserAttributeCode.default.REAGENT,
  work_school_name: '',
  affiliation_department_name: '',
  postal_cd: '',
  todohuken_name: '',
  street_address: '',
  phone_number: '',
});

/**
 * エラーチップを初期化
 */
const resetError = async () => {
  errMessage.value = '';
  isMessageChip.value = false;
};

/**
 * 会員情報取得
 */
const getMemberInfo = async () => {
  // Loading Start
  Loading.show();
  errMessage.value = '';
  isMessageChip.value = false;
  // 会員情報取得
  axios
    .post('/cmi001001/memberInfo')
    .then((res) => {
      const { common } = res.data;
      switch (common.status) {
        // 正常終了の場合
        case ResultStatusCode.SUCCESS:
          mKaiinInfo.user_name_sei = res.data.mkaiin.user_name_sei;
          mKaiinInfo.user_name_mei = res.data.mkaiin.user_name_mei;
          mKaiinInfo.mail_address = res.data.mkaiin.mail_address;
          mKaiinInfo.user_attribute = res.data.mkaiin.user_attribute;
          mKaiinInfo.work_school_name = res.data.mkaiin.work_school_name;
          mKaiinInfo.affiliation_department_name = res.data.mkaiin.affiliation_department_name;
          mKaiinInfo.postal_cd = res.data.mkaiin.postal_cd;
          mKaiinInfo.todohuken_name = res.data.mkaiin.todohuken_name;
          mKaiinInfo.street_address = res.data.mkaiin.street_address;
          mKaiinInfo.phone_number = res.data.mkaiin.phone_number;
          break;
        // エラーの場合
        case ResultStatusCode.ERROR:
          // エラーメッセージ表示
          errMessage.value = common.message;
          isMessageChip.value = true;
          break;
        default:
          router.push({ name: 'error' });
      }
    })
    .catch(() => {
      router.push({ name: 'error' });
    })
    .catch((err) => {
      if (err.res.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        // その他エラーの場合
        router.push({ name: 'error' });
      }
    })
    .finally(() => {
      // Loading End
      Loading.hide();
    });
};

/**
 * 会員情報変更
 */
const memberInfoUpdate = async () => {
  isConfirmationFlg.value = false;
  // Loading Start
  Loading.show();
  errMessage.value = '';
  isMessageChip.value = false;
  // 変更データ作成
  const formData = new FormData();
  formData.append('user_name_sei', mKaiinInfo.user_name_sei);
  formData.append('user_name_mei', mKaiinInfo.user_name_mei);
  formData.append('user_attribute', mKaiinInfo.user_attribute);
  formData.append('work_school_name', mKaiinInfo.work_school_name);
  formData.append('affiliation_department_name', mKaiinInfo.affiliation_department_name);
  formData.append('postal_cd', mKaiinInfo.postal_cd);
  formData.append('todohuken_name', mKaiinInfo.todohuken_name);
  formData.append('street_address', mKaiinInfo.street_address);
  formData.append('phone_number', mKaiinInfo.phone_number);
  // 会員情報変更
  await axios
    .post('/cmi002001/edit', formData)
    .then((res) => {
      const { common } = res.data;
      switch (common.status) {
        // 正常終了の場合
        case ResultStatusCode.SUCCESS:
          // ダイアログ表示
          updateFlg.value = true;
          break;
        // エラーの場合
        case ResultStatusCode.ERROR:
          switch (common.detail_status) {
            // システムエラーの場合
            case DetailResultStatusCode.PARAMETER_ERROR:
            case DetailResultStatusCode.SYSTEM_ERROR:
            case DetailResultStatusCode.UPDATE_ERROR:
              errMessage.value = common.message;
              isMessageChip.value = true;
              break;
            default:
              router.push({ name: 'error' });
          }
          break;
        default:
          router.push({ name: 'error' });
      }
    })
    .catch((err) => {
      if (err.res.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        // その他エラーの場合
        router.push({ name: 'error' });
      }
    })
    .finally(() => {
      // Loading End
      Loading.hide();
    });
};

/**
 * 会員情報画面に戻る
 */
const returnMemberInfo = async () => {
  router.push({ name: 'memberInfo' });
};

// 初期表示処理
getMemberInfo();

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_form = _resolveComponent("q-form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(PageHeaderBanner, null, {
        title: _withCtx(() => _cache[6] || (_cache[6] = [
          _createTextVNode("会員情報変更")
        ])),
        _: 1
      }),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(MessageChip, {
          display: isMessageChip.value,
          level: "E",
          message: errMessage.value
        }, null, 8, ["display", "message"]),
        _createVNode(InputFormHeader, {
          list: titleList,
          page: page.value
        }, null, 8, ["page"]),
        _createVNode(_component_q_form, {
          autofocus: "",
          greedy: "",
          novalidate: "",
          onSubmit: _cache[2] || (_cache[2] = ($event: any) => (page.value += 1)),
          onValidationError: resetError
        }, {
          default: _withCtx(() => [
            (page.value === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createVNode(UserInfoForm, {
                    "member-info": mKaiinInfo,
                    mode: _unref(DisplayModeCode).CHANGE
                  }, null, 8, ["member-info", "mode"]),
                  _createElementVNode("ul", null, [
                    _createElementVNode("li", null, [
                      _cache[8] || (_cache[8] = _createTextVNode(" メールアドレスの変更はできません。")),
                      _cache[9] || (_cache[9] = _createElementVNode("br", null, null, -1)),
                      _cache[10] || (_cache[10] = _createTextVNode(" お手数ですが変更後のメールアドレスにて再度会員登録いただき、 ")),
                      _createVNode(_component_router_link, {
                        to: { name: 'inquiry' },
                        class: "text-link"
                      }, {
                        default: _withCtx(() => _cache[7] || (_cache[7] = [
                          _createTextVNode("お問い合わせ")
                        ])),
                        _: 1
                      }),
                      _cache[11] || (_cache[11] = _createTextVNode(" より旧アドレスをご連絡ください。 "))
                    ]),
                    _createElementVNode("li", null, [
                      _cache[13] || (_cache[13] = _createTextVNode(" 退会をご希望の方は、")),
                      _createVNode(_component_router_link, {
                        to: { name: 'inquiry' },
                        class: "text-link"
                      }, {
                        default: _withCtx(() => _cache[12] || (_cache[12] = [
                          _createTextVNode("お問い合わせ")
                        ])),
                        _: 1
                      }),
                      _cache[14] || (_cache[14] = _createTextVNode(" よりご連絡ください。 "))
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (page.value === 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createVNode(AfiliationInfoForm, { "member-info": mKaiinInfo }, null, 8, ["member-info"])
                ]))
              : _createCommentVNode("", true),
            (page.value === 2)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createVNode(ConfirmationForm, { "member-info": mKaiinInfo }, null, 8, ["member-info"])
                ]))
              : _createCommentVNode("", true),
            _createVNode(FormFooterBanner, { style: {"position":"inherit"} }, {
              "button-area": _withCtx(() => [
                _createElementVNode("div", null, [
                  (page.value === 0)
                    ? (_openBlock(), _createBlock(_component_q_btn, {
                        key: 0,
                        outline: "",
                        to: { name: 'memberInfo' },
                        style: {"color":"var(--q-delete)","width":"120px"},
                        class: "q-mr-xs",
                        label: "戻る"
                      }))
                    : _createCommentVNode("", true),
                  (page.value === 1 || page.value === 2)
                    ? (_openBlock(), _createBlock(_component_q_btn, {
                        key: 1,
                        color: "primary",
                        outline: "",
                        style: {"width":"120px"},
                        class: "q-mr-xs",
                        icon: "mdi-chevron-left",
                        label: "前へ",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (--page.value))
                      }))
                    : _createCommentVNode("", true),
                  (page.value === 0)
                    ? (_openBlock(), _createBlock(_component_q_btn, {
                        key: 2,
                        color: "primary",
                        outline: "",
                        type: "submit",
                        style: {"width":"120px"},
                        "icon-right": "mdi-chevron-right",
                        label: "次へ"
                      }))
                    : _createCommentVNode("", true),
                  (page.value === 1)
                    ? (_openBlock(), _createBlock(_component_q_btn, {
                        key: 3,
                        color: "primary",
                        outline: "",
                        type: "submit",
                        style: {"width":"120px"},
                        "icon-right": "mdi-chevron-right",
                        label: "次へ"
                      }))
                    : _createCommentVNode("", true),
                  (page.value === 2)
                    ? (_openBlock(), _createBlock(_component_q_btn, {
                        key: 4,
                        color: "primary",
                        style: {"width":"120px"},
                        label: "変更",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (isConfirmationFlg.value = true))
                      }))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(AlertDialog, {
      display: isConfirmationFlg.value,
      level: "information",
      title: "更新確認",
      text: ['入力された内容で更新します。', 'よろしいですか？'],
      onConfirm: _cache[3] || (_cache[3] = ($event: any) => (memberInfoUpdate())),
      onClose: _cache[4] || (_cache[4] = ($event: any) => (isConfirmationFlg.value = false))
    }, null, 8, ["display"]),
    _createVNode(AlertDialog, {
      display: updateFlg.value,
      level: "information",
      confirmation: "",
      title: "更新完了",
      text: ['更新しました。'],
      onComplete: _cache[5] || (_cache[5] = ($event: any) => ((updateFlg.value = false), returnMemberInfo()))
    }, null, 8, ["display"])
  ], 64))
}
}

})